import actions from "./actions";
import getters from "./getters";
import mutations from "./mutations";
import AccountStateEnum from "../enums/AccountStateEnum";
import ViewStateEnum from "../enums/ViewStateEnum";

const state = {
  loading: true,
  isCustomerPage: false,
  filter: { sender: "", subject: "", dateRange: [] },
  pagination: {
    page: 0,
    perPage: 25,
    orderBy: "date",
    order: "desc",
  },
  emails: [],
  accounts: [],
  unprocessedEmailCounts: {},
  templates: [],
  selectedAccount: undefined,
  selectedEmails: [],
  viewState: ViewStateEnum.INBOX,
  accountState: AccountStateEnum.UNPROCESSED,
  sendState: undefined,
  matchState: undefined,
  createEmailCustomerId: undefined,
};

export default {
  namespaced: true,
  state,
  actions,
  getters,
  mutations,
};
